import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function layoutReducer(state = initialState.layout, action) {
	switch (action.type) {
		case types.ACTIVE_TOPNAVITEMID_UPDATED: {
			return Object.assign({}, state, { activeTopNavItemId: action.activeTopNavItemId });
		}

		case types.LAYOUT_UPDATED: {
			return mergeDeep({}, action.body);
		}

		case types.SET_SCOPE: {
			let stateToUpdate = mergeDeep({}, state);
			stateToUpdate.scope = action.body;
			return stateToUpdate;
		}

		default:
			return state;
	}
}
